import type { FaireProductEntity } from "../../entity_types/product";

export const p_3u2utpgefx: FaireProductEntity = {
  token: "p_3u2utpgefx",
  type: "product",
  name: "Neu Side Plate s/2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/26a496e76151f63f84c78299aabefcbca2281724ae2a0060b08efe908f644bcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bedcb6a32477340ff73dc812f01499aefd2ee1676dfc67b1d17f2c2f7119e215.jpeg",
    "https://cdn.faire.com/fastly/b756e9d1027a9d711a0ac26b7dcbc2bd55f544bf7a0bcfa4d48dd73f559d651e.png",
    "https://cdn.faire.com/fastly/96d259f032ace3af26a3559a24ccc34a2f6f00149a92d8e19e41f576c79dea36.jpeg",
    "https://cdn.faire.com/fastly/012cf34979130ffcc745e301eb833499e806b75bf5cf6db1522aa917c32c25a7.jpeg",
    "https://cdn.faire.com/fastly/cc8026a39f7fb22e470056487fd2fd4aea048763f0dfb6ac9947858a8f2d49b9.jpeg",
    "https://cdn.faire.com/fastly/2bd11829747ee61abbd06887ed5a61f3a14d39832d20e72e3854a45eabef514e.png",
    "https://cdn.faire.com/fastly/8a0464b35322d7f65e6040df53daa62e85f5c710d85f556db5f2ca975b963bc5.png",
    "https://cdn.faire.com/fastly/8e45d8cb3379347bb6efc93680e0db6b4463be020fc3b06542ac41ad73df1e08.png",
    "https://cdn.faire.com/fastly/14b6d8deec8ccc8412abe5dfd978387ed78e518c82bd07c6c4c4491552414b34.png",
    "https://cdn.faire.com/fastly/5ca22de2c790f0e011d62a3a519a210ddd6972173c05183fd387ec311d737125.png",
  ],
  priceDollars: 15,
  description:
    "NEU, meaning “new” in German, is a pleasing dinnerware range that pays homage to the Bauhaus ideals where form and detailing is dictated by the function and production of an object. Each piece of Neu is stackable; the punctuated details are designed to maximise storage space.\n\nMaterial: Stoneware\n\nDishwasher and microwave-safe.\n\nSize: Ø 21 x 1.7cm\nSet of 2\n\n𝐒𝐡𝐢𝐩𝐩𝐢𝐧𝐠 𝐚𝐧𝐝 𝐫𝐞𝐭𝐮𝐫𝐧𝐬",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:34.598Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
